import { IconButton } from "@material-ui/core";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Tooltip from "@material-ui/core/Tooltip";
import MovieCreationIcon from "@material-ui/icons/MovieCreation";
import Typography from "@material-ui/core/Typography";
import { GridOverlay } from "@material-ui/data-grid";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppContext from "../../../App/AppContext";
import { SecondaryButton } from "../../../Core/FormInput/index";
import DataGridComp from "../../../Core/Grid";
import AddVideoCategoryModal from "./VideoCategoriesModal";
import VideoList from "./VideoList";
import { getVideoCategories } from "../../../Core/Service/video-service";

const VideoCategories = (props) => {
    const [state, setState] = useState({
        rows: [],
        show: false,
        VideoCategoryDetails: null,
        showDel: false,
        showVideoList: false,
    });

    useEffect(async () => {
        pullVideoCategoriesAndUpdateState();
    }, []);

    const handleUpdate = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                show: true,
                VideoCategoryDetails: params.value.row,
            };
            return nst;
        });
    };

    const handleVideoClick = (params) => {
        setState((st) => {
            const nst = {
                ...st,
                showVideoList: !state.showVideoList,
                VideoCategoryDetails: state.showVideoList ? null : params.value.row,
            };
            return nst;
        });
    }

    const Arrow = (params) => {
        return (
            <>
                <Tooltip title="Update Video Category" aria-label="add">
                    <IconButton size="small" onClick={() => handleUpdate(params)}>
                        <EditOutlinedIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>

                <Tooltip title="Videos" aria-label="add">
                    <IconButton size="small" onClick={() => handleVideoClick(params)}>
                        <MovieCreationIcon color="secondary" fontSize="small" />
                    </IconButton>
                </Tooltip>
            </>
        );
    };

    const column_new = [
        {
            field: "",
            headerName: "Action",
            sortable: false,
            width: 100,
            renderCell: (params) => <Arrow value={params} />,
        },
        {
            field: 'id',
            headerName: 'id',
            width: 200,
            hide: true
        },
        {
            field: "videoCategoryDescription",
            headerName: "Description",
            flex: 1,
        },
        {
            field: "roleID",
            headerName: "Roles",
            flex: 1,
        },
        {
            field: "videoCategoryActive",
            headerName: "Active",
            flex: 1,
        },
    ];

    const pullVideoCategoriesAndUpdateState = async () => {
        let result = await getVideoCategories();
        if (result.success) {
            setState((st) => ({
                ...st,
                rows: result.data.list.map((w) => ({
                    ...w,
                    id: w.videoCategoryID,
                    videoCategoryDescription: w.videoCategoryDescription,
                    videoCategoryActive: w.videoCategoryActive,
                    roleID: w.roles
                })),
                show: false,
                showDel: false,
            }));
        }
        if (!result.success) {
            console.log(result.message)
            // showToast(result.message);
        }
    };

    const handleAdd = (props) => {
        setState((st) => {
            return {
                ...st,
                show: true,
                VideoCategoryDetails: null,
            };
        });
    };

    function CustomNoRowsOverlay() {
        return (
            <GridOverlay>
                <div>No Video Categories available</div>
            </GridOverlay>
        );
    }

    const closeUpdateUser = (refreshGrid) => {
        setState((st) => ({ ...st, show: false, showDel: false, VideoCategoryDetails: null, }));
        refreshGrid && pullVideoCategoriesAndUpdateState();
    };

    return (
        <div style={{ position: "relative" }}>
            {
                state.showVideoList ? <VideoList VideoCategoryDetails={state.VideoCategoryDetails} onCloseFunc={handleVideoClick} /> :
                    <>
                        <div style={{ position: "absolute", right: 0 }}>
                            <SecondaryButton variant="contained" color="secondary" onClick={handleAdd} className="btnadd">
                                Add Video Category
                            </SecondaryButton>
                        </div>
                        {state.show ? (
                            <AddVideoCategoryModal onFormSubmit={closeUpdateUser} VideoCategoryDetails={state.VideoCategoryDetails} />
                        ) : null}
                        <Breadcrumbs separator=">>" aria-label="breadcrumb">
                            <Link color="inherit" to={"/"}>
                                Home
                            </Link>
                            <Typography color="secondary" style={{ fontSize: "0.85rem" }}>
                                Video Categories
                            </Typography>
                        </Breadcrumbs>
                        <DataGridComp rows={state.rows} columns={column_new} enableSearch={true} offset={244} CustomNoRowsOverlay={CustomNoRowsOverlay} />
                    </>
            }
        </div>
    );
};
export default VideoCategories;